import React from 'react';
import DaumPostcode from 'react-daum-postcode';

const AddressCustom = ({ isOpen, onClose, onComplete }) => {
    if (!isOpen) return null;

    return (
        <div className="address-modal-overlay">
            <div className="address-modal-container">
                <div className="address-modal-header">
                    <h5>우편번호 검색</h5>
                    <button onClick={onClose} className="close-button">
                        ×
                    </button>
                </div>
                <div className="border-bt"></div>
                <div className="address-modal-content">
                    <DaumPostcode
                        onComplete={(data) => {
                            onComplete(data);
                            onClose();
                        }}
                        style={{ width: '100%', height: '450px' }}
                    />
                </div>

                {/* Custom footer thay thế cho popup_foot */}
                {/* <div className="address-modal-footer custom-popup-foot"></div> */}
            </div>
        </div>
    );
};

export default AddressCustom;
